<template>
  <div class="text-center">
    <b-list-group >
      <b-list-group-item v-for="board in boards" :key="board.id" class="game">
        <div class="board-image">
          <img v-if="board.id" width="64" height="64" :src="backendUrl+'/game-images/'+board.imagePath+'.jpg'"/>
          <img v-if="!board.id" width="64" height="64" src="@/assets/matt-icons_dialog-question.svg"/>
          <b-button v-if="currentUser === board.creator" class="edit-button" variant="primary" @click="$emit('edit-board', board)">Modifier</b-button>
        </div>
        <div class="board-header">
          <span v-if="!board.external_link || board.external_link === ''" class="game-name">{{ board.name }}</span> 
          <a v-if="board.external_link && board.external_link !== ''" class="game-name game-link" :href="board.external_link" target="_blank" >{{ board.name }}<i class="fas fa-external-link-alt"></i></a> 
          <span class="board-detail" v-if="board.creatorData">{{board.minPlayers}} à {{board.maxPlayers}} joueurs, proposé par {{board.creatorData.prenom}} {{board.creatorData.nom}}</span>
        </div>
        <div class="board-players">
          <span class="avatar-wrapper" v-for="player in board.players" :key="player.email">
            <Avatar :user="player"/>
          </span>
          <span v-if="(!board.id || (board.players.length < board.maxPlayers)) && currentUser" class="avatar-wrapper clickable" @click="subcribeAt(board)">
            <Avatar fake="+" fakeTip="s'inscrire"/>
          </span>
          <span v-if="board.id">
            <span class="avatar-wrapper" :key="index" 
                v-for="index in (new Array(board.maxPlayers-board.players.length-((board.players.length < board.maxPlayers && currentUser) ? 1 : 0)))">
              <Avatar fake=" "/>
            </span>
          </span>
          <b-button v-if="alreadySubscribedAt(board)" class="float-right" variant="outline-danger" @click="unsubcribeFrom(board)">Se désinscrire</b-button>
        </div>
      </b-list-group-item>
    </b-list-group>
    
    <b-modal v-model="warnMultipleSubscriptions" title="Attention" @ok="applyUnsubscribe()" >
      <div>
        Attention, toutes les places que vous avez réservées sur cette table seront libérées.
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import Avatar from '@/components/parts/Avatar'
export default {
  name: 'GameList',
  props: ['boards'],
  components:{
    Avatar,
  },
  data: function(){
    return {
      url: Vue.$custom.urlFormat,
      backendUrl: Vue.$backend.getBackendUrl(),
      loggedin: Vue.$isConnected(),
      warnMultipleSubscriptions: false,
      board: null,
    }
  },
  computed:{
    currentUser: function(){
      return Vue.$getUserEmail()
    }
  },
  methods:{
    alreadySubscribedAt: function (board) {
      if(!this.currentUser){
        return false
      }
      for(const player of board.players){
        if(this.currentUser === player.email){
          return true
        }
      }
      return false
    },
    subcribeAt: function(board){
      Vue.$backend.subscribeToBoard(board)
      .then(() => {
        return Vue.$backend.getData()
      })
      .then((data) => {
        board.players.push(data)
      })
    },
    unsubcribeFrom: function(board) {
      this.board = board
      
      let subCount = 0;
      for(let i=0; i < board.players.length; i++){
        if(this.currentUser === board.players[i].email){
          subCount++
        }
      }
      
      if(subCount > 1){
        this.warnMultipleSubscriptions = true
      } else {
        this.applyUnsubscribe()
      }
    },
    applyUnsubscribe: function(){
      const that = this
      Vue.$backend.unsubscribeFromBoard(this.board)
      .then(() => {
        for(let i=0; i < this.board.players.length; i++){
          while(that.currentUser === this.board.players[i].email){
            that.$delete(this.board.players, i)
          }
        }
        that.$forceUpdate()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.game {
  text-align: left;
}

.board-image{
  float: left;
  margin-right: 15px;
}

.board-detail{
  color: darkgray;
  font-size: 12px;
  font-style: italic;
}

.game-name{
  font-size: 20px;
  margin-right: 10px;
}

.avatar-wrapper{
  margin: 2px;
  display: inline-block;
}

.edit-button{
  display: block;
  padding: 2px;
  margin-top: 5px;
}

.game-link{
  color: black;
}
.game-link i{
  font-size: 10px;
  vertical-align: 5px;
  padding-left: 2px;
}

</style>
